import jwt from 'jsonwebtoken';
import CryptoJS from 'crypto-js';

export const createToken = (data, privatekey) => {
  
  const privateKey = privatekey
  const paramsOption = {
    algorithm: 'RS256',
    expiresIn: '2 days'
  };
  const formattedPrivateKey = formatPrivateKey(privateKey);
  const token = jwt.sign(data, formattedPrivateKey, paramsOption);
  return token;
};
const formatPrivateKey = (privateKey) => {
  const begin = '-----BEGIN RSA PRIVATE KEY-----\n';
  const end = '\n-----END RSA PRIVATE KEY-----';
  // Use a regular expression to insert newlines every 64 characters
  const formattedKey = privateKey.replace(/(.{64})/g, '$1\n');

  return `${begin}${formattedKey}${end}`;
};
export const encrypt = (data, encryptionKey) => {
  const ivKey = encryptionKey;
  if (ivKey) {
    const binaryEncryptionKey = CryptoJS.enc.Base64.parse(ivKey);
    const cipher = CryptoJS.AES.encrypt(data, binaryEncryptionKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return cipher.toString();
  }
};

export const decrypt = (encryptedData, encryptionKey) => {
  const ivKey = encryptionKey;
  if (ivKey) {
    const binaryEncryptionKey = CryptoJS.enc.Base64.parse(ivKey);
    const bytes = CryptoJS.AES.decrypt(encryptedData, binaryEncryptionKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return bytes.toString(CryptoJS.enc.Utf8);
  }
};


export const formatDateByLocale = (date, locale) => {
  // Check if the input is in ISO 8601 format (YYYY-MM-DDTHH:mm:ss.sssZ)
  if (typeof date === 'string' && date.includes('T')) {
    const dateObj = new Date(date);

    if (isNaN(dateObj.getTime())) {
      console.error('Invalid date');
      return date;
    }

    // Format the date according to the specified locale
    if (locale === 'en' || locale === 'fr') {
      // English format: MM/DD/YYYY hh:mm:ss AM/PM
      const ampm = dateObj.getHours() >= 12 ? 'PM' : 'AM';
      const formattedHours = dateObj.getHours() % 12 || 12; // Convert 24h to 12h format
      return `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getDate().toString().padStart(2, '0')}/${dateObj.getFullYear()} ${formattedHours.toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}:${dateObj.getSeconds().toString().padStart(2, '0')} ${ampm}`;
    } else {
      // German format: DD.MM.YYYY HH:mm:ss
      return `${dateObj.getDate().toString().padStart(2, '0')}.${(dateObj.getMonth() + 1).toString().padStart(2, '0')}.${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}:${dateObj.getSeconds().toString().padStart(2, '0')}`;
    }
  }

  // Custom format handling: DD.MM.YYYY or DD.MM.YYYY HH:mm:ss
  if (typeof date !== 'string') {
    console.error('Invalid input: expected a string in DD.MM.YYYY or DD.MM.YYYY HH:mm:ss format');
    return date;
  }

  const dateRegex1 = /^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/;
  const matchDate = date.match(dateRegex1);

  if (matchDate) {
    const [, year, month, day, hours, minutes, seconds] = matchDate;

    const formatdate = (locale === 'de') 
    ? `${day}.${month}.${year} ${hours}:${minutes}:${seconds}` 
    : `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;

    return formatdate
  }

  // Regex: YYYY-MM-DD ("2025-05-26") 
  const regexFormat1 = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
  const matchDateFormat1 = date.match(regexFormat1);

  if(matchDateFormat1){
    const dateObj = new Date(date);

    if (locale === 'en' || locale === 'fr'){
      return new Intl.DateTimeFormat("en-US", {
        year: "numeric",  
        month: "2-digit",  
        day: "2-digit"    
      }).format(dateObj);
    }else{
      return new Intl.DateTimeFormat("de-DE", {
        year: "numeric",   
        month: "2-digit",  
        day: "2-digit"     
      }).format(dateObj); 
    }
  }

  
  const dateRegex = /^(\d{2})\.(\d{2})\.(\d{4})(?:\s(\d{2}):(\d{2}):(\d{2}))?$/;
  const match = date.match(dateRegex);

  if (!match) {
    console.error('Invalid date format. Expected DD.MM.YYYY or DD.MM.YYYY HH:mm:ss');
    return date;
  }

  const [, day, month, year, hours = '00', minutes = '00', seconds = '00'] = match;
  const dateObj = new Date(year, month - 1, day, hours, minutes, seconds);

  if (isNaN(dateObj.getTime())) {
    console.error('Invalid date');
    return date;
  }

  // Format the date for the specified locale
  if (locale === 'en' || locale === 'fr') {
    const ampm = dateObj.getHours() >= 12 ? 'PM' : 'AM';
    const formattedHours = dateObj.getHours() % 12 || 12;
    return `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getDate().toString().padStart(2, '0')}/${dateObj.getFullYear()} ${formattedHours.toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}:${dateObj.getSeconds().toString().padStart(2, '0')} ${ampm}`;
  } else {
    return `${dateObj.getDate().toString().padStart(2, '0')}.${(dateObj.getMonth() + 1).toString().padStart(2, '0')}.${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}:${dateObj.getSeconds().toString().padStart(2, '0')}`;
  }
};

export const formatOnlyDateByLocale = (date, locale) => {
  // Check if the input is in ISO 8601 format (YYYY-MM-DDTHH:mm:ss.sssZ)

  const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
  const matchDate2 = regex.test(date);

  if (typeof date === 'string' && date.includes('T') || matchDate2) {
    const dateObj = new Date(date);

    if (isNaN(dateObj.getTime())) {
      console.error('Invalid date');
      return date;
    }

    // Format the date according to the specified locale
    if (locale === 'en' || locale === 'fr') {
      // English format: MM/DD/YYYY
      return `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getDate().toString().padStart(2, '0')}/${dateObj.getFullYear()}`;
    } else {
      // German format: DD.MM.YYYY
      return `${dateObj.getDate().toString().padStart(2, '0')}.${(dateObj.getMonth() + 1).toString().padStart(2, '0')}.${dateObj.getFullYear()}`;
    }
  }

  // Custom format handling: DD.MM.YYYY or DD.MM.YYYY HH:mm:ss
  if (typeof date !== 'string') {
    console.error('Invalid input: expected a string in DD.MM.YYYY or DD.MM.YYYY HH:mm:ss format');
    return date;
  }

  const dateRegex1 = /^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/;
  const matchDate = date.match(dateRegex1);

  if (matchDate) {
    const [, year, month, day] = matchDate;

    const formatdate = (locale === 'de') 
      ? `${day}.${month}.${year}` 
      : `${month}/${day}/${year}`;

    return formatdate;
  }

  const dateRegex = /^(\d{2})\.(\d{2})\.(\d{4})(?:\s(\d{2}):(\d{2}):(\d{2}))?$/;
  const match = date.match(dateRegex);

  if (!match) {
    console.error('Invalid date format. Expected DD.MM.YYYY or DD.MM.YYYY HH:mm:ss');
    return date;
  }

  const [, day, month, year] = match;
  const dateObj = new Date(year, month - 1, day);

  if (isNaN(dateObj.getTime())) {
    console.error('Invalid date');
    return date;
  }

  // Format the date for the specified locale
  if (locale === 'en' || locale === 'fr') {
    return `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getDate().toString().padStart(2, '0')}/${dateObj.getFullYear()}`;
  } else {
    return `${dateObj.getDate().toString().padStart(2, '0')}.${(dateObj.getMonth() + 1).toString().padStart(2, '0')}.${dateObj.getFullYear()}`;
  }
};

export const clearCookieStorage = (encryptionKey, hotReload = false) => {

  (async () => {
    let cookies = document.cookie.split("; ");
    for (let c = 0; c < cookies.length; c++) {
      let d = window.location.hostname.split(".");
      while (d.length > 0) {
        let cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
        let p = window.location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        }
        d.shift();
      }
    }
    const host = window.location.host;
    const parts = host.split(".");
    parts.shift();

    let redirectUrl = localStorage.getItem('redirectLogin');
    let encryptedData = encrypt(window.location.href, encryptionKey);
    
    let result = redirectUrl.replace(/"/g, '');
    localStorage.clear();
    window.location.assign(result + 'auth/logout/' + encodeURIComponent(encryptedData));
    // await redirectToLogin(encryptionKey);
    
  })();
  if (hotReload)
    window.location.reload();
}

export const formatDate = (date, isStartOfDay = true) => {
  const localDate = new Date(date);

  if (isStartOfDay) {
    localDate.setHours(0, 0, 0, 0);
  } else {
    localDate.setHours(23, 59, 59, 999);
  }

  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, '0');
  const day = String(localDate.getDate()).padStart(2, '0');

  // Return the formatted date as ISO string
  return `${year}-${month}-${day}T${isStartOfDay ? '00:00:00.000' : '23:59:59.999'}`;
};
export const formatValidDate = (date = true) => {
  const localDate = new Date(date);
  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, '0');
  const day = String(localDate.getDate()).padStart(2, '0');

  // Return the formatted date as ISO string
  return `${year}-${month}-${day}`;
};
export const isValidDate = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const today = new Date();

  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  // Validate start date: it should be a valid date and <= today
  const isStartDateValid = !isNaN(start.getTime()) && start <= today;

  // Validate end date: it should be a valid date and >= start date
  const isEndDateValid = !isNaN(end.getTime()) && end >= start;
  return { isStartDateValid, isEndDateValid };
};

export const redirectToLogin = (encryptionKey) => {
  let redirectUrl = localStorage.getItem('redirectLogin');
  let encryptedData = encrypt(window.location.href, encryptionKey);

  let result = redirectUrl.replace(/"/g, '');

  window.location.assign(result + 'auth/login/' + encodeURIComponent(encryptedData));

}

// New Validation Function for Text Inputs - it checks for letters
export const validateTextInput = (value) => /^[A-Za-zäöüÄÖÜß\s]*$/.test(value);

export const checkVersionMismatch = (latestVersion, currentVersion) => {
  const latest = latestVersion.split('.');
  const current = currentVersion.split('.');

  while (latest.length || current.length) {
    const a = Number(latest.shift());
    const b = Number(current.shift());

    if (a === b) continue;
    return a > b || isNaN(b);
  }

  return false;
};

export const formattedAmount = (amount, locale) => {
  let amountValue = parseFloat(amount);
  if (locale === 'en' || locale === 'fr') {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amountValue);
  } else {
    return new Intl.NumberFormat("de-CH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amountValue);
  }
}

